export const getAllNode = (arr, name, childName) => {
    let str
    const arrs = []
    if (!arr) {
      return
    }
    if (!name) {
      name = 'id'
    }
    if (!childName) {
      childName = 'children'
    }
    const getChild = (arr) => {
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i][name])
        if (arr[i][childName] && arr[i][childName].length > 0) {
          getChild(arr[i].children)
        }
      }
      str = arrs
  
      return str
    }
    return getChild(arr)
  }
  export const getAllKey = (arr, name, childName) => {
    let str
    const arrs = []
    var nodes = []
    if (!arr) {
      return
    }
    if (!name) {
      name = 'id'
    }
    if (!childName) {
      childName = 'children'
    }
    const getChild = (arr) => {
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i][name])
        if (arr[i][childName] && arr[i][childName].length > 0) {
          getChild(arr[i].children)
        } else {
          if (arr[i].checked == true) {
            nodes.push(arr[i].id)
          } 
        }
      }
      str = nodes
  
      return str
    }
    return getChild(arr)
  }
  